import { createBrowserHistory } from 'history';
import {
  getPathnameForAnalytics,
  trackAnalyticEvent,
} from 'common/utils/client-analytics.util';

const _history = createBrowserHistory();

_history._push = _history.push;
_history.push = (url) => {
  _history._push(url);
};

_history._replace = _history.replace;
_history.replace = (url) => {
  _history._replace(url);
};

_history.listen((location) => {
  if (location.pathname !== '/') {
    trackAnalyticEvent(`${getPathnameForAnalytics(location.pathname)}-visit`);
  }
});

export default _history;
